import '@fancyapps/fancybox/dist/jquery.fancybox.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';

$(document).ready(function () {

    $().fancybox({
      selector : '.slick-slide:not(.slick-cloned) .js-fancybox',
      hash     : false
    });

    // cover slider at home page

    (() => {

        let sliderItem = $('.js-slider-item'),
            indicatorItem = $('.js-indicator'),
            currentNum = $('.js-current'),
            lengthOfSlider = $('.js-length'),
            btnLeft = $('.js-slider-left'),
            btnRight = $('.js-slider-right'),
            video = $('.js-video iframe'),
            wrapper = sliderItem.parents('.slider');

        document.documentElement.addEventListener('homePageLoad', () => {

            function getActiveIndex(arr) {

                let index = 0;

                arr.each(function (i) {

                    if (arr.eq(i).hasClass('active')) {
                        index = i;
                        return false;
                    }

                });

                return index;

            }

            function equalName(name) {

                let index = 0;

                sliderItem.each(function (i) {

                    if (sliderItem.eq(i).attr('data-name').toLowerCase() === name.toLowerCase()) {

                        index = i;

                    }

                });

                return index;

            }

            function setNumber(selector, number) {
                if (number < 10) {
                    selector.text('0' + number);
                } else {
                    selector.text(number + '');
                }
            }

            function addRemoveClass(element, time, cls) {

                element.addClass(cls);

                setTimeout(function () {

                    element.removeClass(cls);

                }, time);

            }

            function clearClass(arr, cls) {

                arr.each(function (index) {

                    arr.eq(index).removeClass(cls);

                })

            }

            // animate forward function

            function animateForward(arr) {

                let index = getActiveIndex(arr);

                addRemoveClass(arr.eq(index), 500, 'animate-forward');

                return index;

            }

            // main slider animation

            function mainAnimate(index) {
                wrapper.trigger('change', [sliderItem.eq(index)]);
                setNumber(currentNum, (index + 1));
                clearClass(indicatorItem, 'active');
                indicatorItem.eq(index).addClass('active');
                addRemoveClass(wrapper, 1200, 'disabled');
                clearClass(sliderItem, 'active');
                sliderItem.eq(index).addClass('active');
                setTimeout(function () {
                    video.attr('src', sliderItem.eq(index).attr('data-video-src'));
                }, 1000);

            }

            // first initialize

            sliderItem.eq(0).addClass('active');
            wrapper[0].initialSlide = sliderItem.eq(0);
            indicatorItem.eq(getActiveIndex(sliderItem)).addClass('active');
            setNumber(lengthOfSlider, sliderItem.length);
            setTimeout(function () {
                video.attr('src', sliderItem.eq(0).attr('data-video-src'));
            }, 1000);

            // right click

            btnLeft.click(function () {

                let index = animateForward(sliderItem);

                index--;
                if (index < 0) {
                    index = sliderItem.length - 1;
                }

                mainAnimate(index);

            });

            // left click

            btnRight.click(function () {

                let index = animateForward(sliderItem);

                index++;
                if (index > sliderItem.length - 1) {
                    index = 0;
                }
                mainAnimate(index);

            });

            // click on left side menu

            indicatorItem.hover(function () {

                animateForward(sliderItem);

                let i = equalName($(this).attr('data-name'));

                mainAnimate(i);

            }, function () {
                return false;
            });


            // mobile touch events

            let draggable = false,
                start,
                end;

            function handleStart(e) {
                start = e.targetTouches[0].clientX;
                console.log(start);
            }

            function handleMove(e) {
                end = e.targetTouches[0].clientX;
                draggable = true
            }

            function handleEnd() {
                if (draggable) {
                    console.log(end);
                    if (end > (start + 50)) {

                        let index = animateForward(sliderItem);

                        index--;
                        if (index < 0) {
                            index = sliderItem.length - 1;
                        }

                        mainAnimate(index);

                    } else if (end < (start - 50)) {

                        let index = animateForward(sliderItem);

                        index++;
                        if (index > sliderItem.length - 1) {
                            index = 0;
                        }

                        mainAnimate(index);
                    }
                }
                draggable = false;
            }

            if (sliderItem.length) {

                sliderItem[0].parentNode.addEventListener('touchstart', handleStart, false);
                sliderItem[0].parentNode.addEventListener('touchmove', handleMove, false);
                sliderItem[0].parentNode.addEventListener('touchend', handleEnd, false);

            }

        });


    })();

    // sale slick carousel

    (() => {

        $('.js-sale-slider').slick({
            infinite: true,
            centerMode: true,
            centerPadding: 0,
            initialSlide: 1,
            slidesToShow: 3,
            slidesToScroll: 1,
            speed: 700,
            prevArrow: $('.js-left-btn'),
            nextArrow: $('.js-right-btn'),
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        draggable: true,
                        arrows: false,
                        speed: 500
                    }
                }
            ],

        });

        // for edit mode

        if ($('html').hasClass('ccm-edit-mode')) {

            $('.js-sale-slider').slick('unslick');

        }


    })();

});



// WEBPACK FOOTER //
// ./scripts/slider.js